import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppLayout } from "views/layouts/AppLayout";
import { Dashboard } from "./Dashboard";
import { Projects } from "./Projects";
import { ProjectSettings } from "./ProjectSettings";
import { Tasks } from "./Tasks";
import { Tools } from "./Tools";
import { Notes } from "./Notes";
import { EditorLayout } from "views/layouts/EditorLayout";
import { NoteEditor } from "./NoteEditor";
import { Clothoide } from "./roadTools/Clothoide";
import { Vertical } from "./roadTools/Vertical";
import { Acceleration } from "./roadTools/Acceleration";
import { Retardation } from "./roadTools/Retardation";
import { Overtaking } from "./roadTools/Overtaking";
import { Widening } from "./roadTools/Widening";
import { Superelevation } from "./roadTools/Superelevation";
import { ResSlope } from "./roadTools/ResSlope";
import { Leftturn } from "./trafficTools/Leftturn";
import { Aadt } from "./trafficTools/Aadt";
import { Forces } from "./trafficTools/Forces";
import { Signal } from "./trafficTools/Signal";
import { Repositories } from "./Repositories";

export const router = createBrowserRouter([
    {
        element: <AppLayout/>,
        children: [
            {
                path: '/',
                element: <Navigate to='/dashboard' replace/>
            },
            {
                path: '/dashboard',
                element: <Dashboard/>
            },
            {
                path: '/projects',
                element: <Projects/>
            },
            {
                path: '/projects/:projectUuid',
                element: <ProjectSettings/>
            },
            {
                path: '/projects/:projectUuid/task/:taskUuid',
                element: <ProjectSettings/>
            },
            {
                path: '/tasks',
                element: <Tasks/>
            },
            {
                path: '/tasks/:taskUuid',
                element: <Tasks/>
            },
            {
                path: '/tools',
                element: <Tools/>,
                children: [
                    {
                        index: true,
                        element: <Navigate to='clothoide' replace/>
                    },
                    {
                        path: 'clothoide',
                        element: <Clothoide/>,
                        handle: {title: "Klotoideparameter"}
                    },
                    {
                        path: 'vertical',
                        element: <Vertical/>,
                        handle: {title: "Vertikalgeometri"}
                    },
                    {
                        path: 'acceleration',
                        element: <Acceleration/>,
                        handle: {title: "Akselerasjonsfelt"}
                    },
                    {
                        path: 'retardation',
                        element: <Retardation/>,
                        handle: {title: "Retardasjonsfelt"}
                    },
                    {
                        path: 'overtaking',
                        element: <Overtaking/>,
                        handle: {title: "Forbikjøring"}
                    },
                    {
                        path: 'superelevation',
                        element: <Superelevation/>,
                        handle: {title: "Overhøyde og tverrfall"}
                    },
                    {
                        path: 'widening',
                        element: <Widening/>,
                        handle: {title: "Breddeutvidelse"}
                    },
                    {
                        path: 'resslope',
                        element: <ResSlope/>,
                        handle: {title: "Resuleterende fall"}
                    },
                    {
                        path: 'leftturn',
                        element: <Leftturn/>,
                        handle: {title: "Venstresvingsfelt"}
                    },
                    {
                        path: 'aadt',
                        element: <Aadt/>,
                        handle: {title: "Timetrafikk fra ÅDT"}
                    },
                    {
                        path: 'forces',
                        element: <Forces/>,
                        handle: {title: "Fysiske krefter"}
                    },
                    {
                        path: 'signal',
                        element: <Signal/>,
                        handle: {title: "Skytesignalanlegg"}
                    }
                ]
            },
            {
                path: 'notes',
                element: <Notes/>
            },
            {
                path: 'repositories',
                element: <Repositories/>
            },
            {
                path: '*',
                element: <Dashboard/>
            }
        ]
    },
    {
        element: <EditorLayout/>,
        children: [
            {
                path: '/doc/:noteUuid',
                element: <NoteEditor/>
            }
        ]
    }
])